import React, { useEffect, useState, useRef, useCallback } from "react";
import nodata from "../../assets/img/no-data.svg";
import { USDTWithdrawalHistory } from "../../api/apiService";
import { useToken } from "../../components/TokenContext";
import Loader from "../../components/Loader";

const WalletStatement = () => {


  

 // State for mobile filter visibility
  const [showFilter, setShowFilter] = useState(false);

  // Functions to toggle/close filter
  const toggleFilter = () => setShowFilter(!showFilter);
  const closeFilter = () => setShowFilter(false);






  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [status, setStatus] = useState("");
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [copiedWallet, setCopiedWallet] = useState(null);

  const { token, fetchToken } = useToken();

  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  const rowsPerPage = process.env.REACT_ROW_PER_PAGE || 100;

  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const formatBalance = (balance) => balance ? parseFloat(balance).toLocaleString(): "";

  // Format DateTime
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      // hour: "2-digit",
      // minute: "2-digit",
      // second: "2-digit",
      // hour12: true,
    });
  };

  const copyWallet = (wallet) => {
    navigator.clipboard.writeText(wallet);
    setCopiedWallet(wallet);
    setTimeout(() => setCopiedWallet(null), 2000);
  };

  // Fetch Wallet Statement
  const fetchWithdrawalHistory = useCallback(
    async (page,status) => {
      setLoading(true);
      try {
        // Make Sure We Have Token
        let currentToken = token || (await fetchToken());
        if (!currentToken) return;
        const loginToken = localStorage.getItem("LoginToken") || currentToken;
        const response = await USDTWithdrawalHistory(
          currentToken,
          loginToken,
          page,
          rowsPerPage,
          "",
          "",
          fromDate,
          toDate,
          status
        );
        if (response.status) {
          const dataList = response.DataList || [];
          setTableData(dataList);
          setTotalRecords(response.TotalRecords || dataList.length);
        } else {
          setTableData([]);
          setTotalRecords(0);
        }
      } 
      catch (error) {
        setTableData([]);
        setTotalRecords(0);
      } 
      finally {
        setLoading(false);
      }
    },
    [fromDate, toDate, token, fetchToken]
  );


  // Initial Load & Whenever Page Changes
  useEffect(() => {
    fetchWithdrawalHistory(currentPage,status);
  }, [fetchWithdrawalHistory, currentPage]);

  // Handle Search
  const handleSearch = () => {
    const page = 1;
    setCurrentPage(page);
    fetchWithdrawalHistory(page,status); // Pass Values Directly
  };

  // Handle Reset
  const handleReset = () => {
    setFromDate("");
    setToDate("");
    setStatus("");
    const page = 1;
    setCurrentPage(page);
    fetchWithdrawalHistory(page,""); // Reset Search
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
 
        <div className="buyshheikh-page">
          <div className="pageTitle">USDT Withdrawal History 
        {/* Mobile Filter Button */}
        <button
          className="mobile-filter-btn d-md-none"
          onClick={toggleFilter}
        >
          Filter <i className="fa fa-filter"></i>
        </button>
        
        </div>
          <div className="card mb-3">
            <div className="card-body">
          {/* Filters */}

          {showFilter && <div className="overlay" onClick={closeFilter}></div>}

          {/* Filter Card */}
          <div className={`filter-card ${showFilter ? "show" : ""}`}>
         <span className="badge bg-danger closefilter-btn"     onClick={closeFilter} >   <i class="fa-solid fa-xmark"></i></span>
              <div className="row">
                {/* From Date */}
                <div className="col-md-6 col-lg-2 mb-3">
                  <label htmlFor="fromDate" className="form-label">From Date</label>
                  <div className="input-icon">
                    <input
                      ref={fromDateRef}
                      type="date"
                      id="fromDate"
                      className="form-control form-control-new no-calendar-icon"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      onClick={() => fromDateRef.current?.showPicker()}
                    />
                    <i className="fa-solid fa-calendar iconposition"></i>
                  </div>
                </div>

                {/* To Date */}
                <div className="col-md-6 col-lg-2 mb-3">
                  <label htmlFor="toDate" className="form-label">To Date</label>
                  <div className="input-icon">
                    <input
                      ref={toDateRef}
                      type="date"
                      id="toDate"
                      className="form-control form-control-new no-calendar-icon"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      onClick={() => toDateRef.current?.showPicker()}
                    />
                    <i className="fa-solid fa-calendar iconposition"></i>
                  </div>
                </div>

                {/* Withdrawal Status */}
                <div className="col-md-6 col-lg-3 mb-3">
                  <div className="form-group">
                    <label htmlFor="status" className="form-label">Search Status</label>
                     <div className="input-icon">
                    <select
                      className="form-control form-control-new"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value="">Select Status</option>
                      <option value="0">Pending</option>
                      <option value="1">Approved</option>
                      <option value="2">Rejected</option>
                    </select>
                     <i className="fa-solid fa-wallet iconposition"></i> 
                    </div>
                  </div>
                </div>

                {/* Buttons */}
                <div className="col-md-6 col-lg-3 mb-3">
                <label className="visibilty-hidden form-label">Search</label>
                <div className="d-flex gap-2">
                    <button className="btn btn-success" onClick={handleSearch}>Search</button>
                    <button className="btn btn-danger" onClick={handleReset}>Reset</button>
                  </div>
                </div>
              </div> 
              </div> 

              {/* Table */}
              <div className="table-responsive">
                <table className="table table-striped table-bordered mytable">
                  <thead className="table-dark">
                    <tr>
                      <th>S.No.</th>
                      <th>Date</th>
                      <th>Wallet</th>
                      <th>Withdrawal Amount</th>                                 
                      <th>Admin Charge</th>
                      <th>Net Payable</th>
                      <th>Hash Code</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="8" className="text-center"> 
                               <Loader /> 
                        </td>
                      </tr>
                    ) : tableData.length ? (
                      tableData.map((row) => (
                        <tr key={row.RowNumber}>
                          <td>{row.RowNumber}</td>
                          <td>{formatDateTime(row.WithdrawalDateTime)}</td>
                          <td>{row.AccountNumber}</td>
                          <td>${row.REQUESTINUSD}</td>
                          <td>${row.ADMINCHARGE}</td>
                          <td>${row.WithdrawalAmount}</td>
                          <td>
                          <div className="d-flex align-items-center gap-2">
                              {/* <span>{row.HASHCODE}</span> */}
                              <span
                                className="copy-walletaddress"
                                onClick={() => copyWallet(row.HASHCODE)}
                              >
                                <i className={`fa ${copiedWallet === row.HASHCODE ? "fa-check" : "fa-copy"}`}></i>
                              </span>
                          </div>
                          </td>
                          {/* <td>{row.ApprovalStatus}</td> */}
                          <td>
                                                    <span
    className={`badge ${
      row.ApprovalStatus === "Pending"
        ? "bg-warning text-dark"
        : row.ApprovalStatus === "Approved"
        ? "bg-success"
        : row.ApprovalStatus === "Rejected"
        ? "bg-danger"
        : "bg-secondary"
    }`}
  >
    {row.ApprovalStatus}
  </span>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          {/* <img src={nodata} className="not-data" alt="No Data" /> */}
                          <div>No records found</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {tableData.length > 0 && (
                <div className="d-flex justify-content-between align-items-center mt-2">
                  <div>
                    Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
                    {currentPage * rowsPerPage > totalRecords ? totalRecords : currentPage * rowsPerPage} of {totalRecords} entries
                  </div>
                  <div>
                    <ul className="pagination mb-0">
                      <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => paginate(currentPage - 1)}>Previous</button>
                      </li>
                      {[...Array(totalPages)].map((_, idx) => (
                        <li key={idx} className={`page-item ${currentPage === idx + 1 ? "active" : ""}`}>
                          <button className="page-link" onClick={() => paginate(idx + 1)}>{idx + 1}</button>
                        </li>
                      ))}
                      <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => paginate(currentPage + 1)}>Next</button>
                      </li>
                    </ul>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>  
  );
};

export default WalletStatement;
